export enum SupportedDeepLinksEnum {
  SET_WINNING_BID = "SET_WINNING_BID",
  BIDDER_SETTINGS = "BIDDER_SETTINGS",
  BIDDING_SETTINGS = "BIDDING_SETTINGS",
}
